import CourseModule from './containers/courseModule'

export {default as CourseModuleLayout} from './components/courseModuleLayout'

export default CourseModule
